import React from 'react';

import { useFileLease } from '@/api/generated';
import { Spinner } from '@/components/ui/spinner';

interface AudioProps {
  id: string;
}

const Audio = ({ id }: AudioProps) => {
  const { data, isPending } = useFileLease(id);

  if (isPending) {
    return <Spinner />;
  }

  if (!data) {
    return null;
  }

  return (
    <audio
      controls
      src={data}
      preload='auto'
      className='primary-foreground'>
      <track kind='captions' />
    </audio>
  );
};

export default Audio;
